import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { TunnelSectionDto } from "src/app/server-api/models";


@Injectable({ providedIn: 'root' })
export class TunnelSectionsService {
  
  toSelectSectionOnMap = new Subject<string>();
  sectionClickedOnMap = new Subject<string>();
      
  
  selectSectionOnMap(id: string)
  {
    this.toSelectSectionOnMap.next(id);
  }

  toSectionClickedOnMap(id: string)
  {
    this.sectionClickedOnMap.next(id);
  }
  
}

